// extracted by mini-css-extract-plugin
export default {"container":"_-_-record-it-components-src-pageContentLayout-PageContentContainer-__container"};